import {createSelector} from "@ngrx/store";
import {IAppState} from "../../state/app.state";
import {IPartnersState} from "../../state/partners/partners.state";

export const selectPartners = createSelector(
  (state: IAppState) => state.partners,
  (state:IPartnersState) => state
);
